var map = {
	"./arrow-down-blue.svg": 474,
	"./arrow-down-grey.svg": 475,
	"./arrow-right.svg": 476,
	"./blue-loader.svg": 71,
	"./circle-grey.svg": 234,
	"./circle.svg": 235,
	"./coinbaseWalletIcon.svg": 155,
	"./crosschain/ESW.svg": 236,
	"./discord.svg": 477,
	"./dropdown-blue.svg": 478,
	"./dropdown-white-select.svg": 479,
	"./dropdown.svg": 480,
	"./dropup-blue.svg": 481,
	"./link.svg": 482,
	"./magnifying-glass.svg": 483,
	"./menu.svg": 484,
	"./metamask-icon.svg": 485,
	"./new-design/Frame.svg": 300,
	"./new-design/arrow-left.svg": 486,
	"./new-design/arrow-right.svg": 487,
	"./new-design/warning.svg": 488,
	"./outside-link.svg": 489,
	"./plus-blue.svg": 490,
	"./plus-grey.svg": 491,
	"./question-mark.svg": 492,
	"./question.svg": 493,
	"./reddit.svg": 494,
	"./small-dropdown-white-select.svg": 237,
	"./spinner.svg": 495,
	"./telegram.svg": 496,
	"./walletConnectIcon.svg": 156,
	"./x.svg": 497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1004;